import * as React from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { IReturnModel } from "../../";
import { UserProfileTower } from "../UserProfileTower";

export interface IUserProfileSectionState {
    switchIcon: boolean;
}

export interface IUserProfileDetails {
    department: string;
    email: string;
    firstName: string;
    icon: string;
    isPermissionProfileInfoEditEnabled: boolean;
    isPermissionProfilePictureEditEnabled: boolean;
    lastName: string;
    phoneNumber: string;
    username: string;
    userTitle: string;
}

const defaultUserProfileSection: IUserProfileDetails = {
    department: ``,
    email: ``,
    firstName: ``,
    icon: `/Images/OperatorIcon`, // Default to the OperatorIcon just in case the user does not have one
    isPermissionProfileInfoEditEnabled: false,
    isPermissionProfilePictureEditEnabled: false,
    lastName: ``,
    phoneNumber: ``,
    userTitle: ``,
    username: ``,
};

export class UserProfileSection extends React.Component<
    IBaseSectionProps,
    IUserProfileSectionState
> {
    private isPasskeyAuthenticationEnabled: string;
    constructor(props: IBaseSectionProps) {
        super(props);
        void this.getPasskeyConfiguration();
        this.state = {
            switchIcon: false,
        };

        void this.getMyProfile();
    }

    private _userProfile: IUserProfileDetails = defaultUserProfileSection;

    public getMyProfile = async (): Promise<void> => {
        const stringResult: string = await $.ajax({
            method: `GET`,
            url: `/Profile/MyProfile`,
        });

        const result: IReturnModel<IUserProfileDetails> =
            JSON.parse(stringResult);

        if (result.isSuccess) {
            this._userProfile = {
                ...this._userProfile,
                ...result.value,
            };

            // Profile details which are held in the state need to be passed too.
            const activeProps: IActiveSectionProps = {
                moduleID: this.props.moduleID,
                sectionType: this.props.sectionType,
                tower: {
                    bindComponent: (
                        <UserProfileTower
                            key={this.props.moduleID}
                            profile={this._userProfile}
                            updateProfile={this.getMyProfile}
                            isPasskeyAuthenticationEnabled={
                                this.isPasskeyAuthenticationEnabled
                            }
                            {...this.props}
                        />
                    ),
                },
            };

            this.props.updateSection(activeProps);
        }
    };

    public getPasskeyConfiguration = async (): Promise<void> => {
        const apiResponse: Response = await fetch(
            `/Account/PasskeyAuthenticationConfig`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );

        this.isPasskeyAuthenticationEnabled = await apiResponse.json();
    };

    private readonly _bindOnClick = (): void => {
        // Profile details which are held in the state need to be passed too.
        void this.getMyProfile();
        const activeProps: IActiveSectionProps = {
            moduleID: this.props.moduleID,
            sectionType: this.props.sectionType,
            tower: {
                bindComponent: (
                    <UserProfileTower
                        key={this.props.moduleID}
                        profile={this._userProfile}
                        updateProfile={this.getMyProfile}
                        isPasskeyAuthenticationEnabled={
                            this.isPasskeyAuthenticationEnabled
                        }
                        {...this.props}
                    />
                ),
            },
        };

        this.props.toggleSection(activeProps, this._activeSectionsComparer);
    };

    private readonly _switchOnHover = (): void => {
        this.setState({
            switchIcon: true,
        });
    };

    private readonly _switchOffHover = (): void => {
        this.setState({
            switchIcon: false,
        });
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    private readonly _activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            const sectionType = activeSections[i].sectionType;

            if (
                sectionType === `MyProfile` ||
                sectionType === `ToolMenu` ||
                sectionType === `Notifications` ||
                sectionType === `ReleaseNotes` ||
                sectionType === `DataFeedStatus` ||
                sectionType === `EditProfile`
            ) {
                activeSections.splice(i, 1);
                i--;
            }
        }

        return activeSections;
    };

    render(): React.ReactElement {
        const operatorColour = `#DDDDDD`,
            profileColour = `#3A5464`;

        // Switch background colour on hover.
        const colour: string = this.state.switchIcon
            ? profileColour
            : operatorColour;

        // Switch image on hover.
        const operatorIcon: number = this.state.switchIcon ? 0 : 1,
            profileIcon: number = this.state.switchIcon ? 1 : 0;

        return (
            <div
                className={`tab-profilesection`}
                onMouseEnter={this._switchOnHover}
                onMouseLeave={this._switchOffHover}
                style={{
                    background: colour,
                }}
            >
                <div
                    className={`profilesection-onclickcontainer`}
                    onClick={this._bindOnClick}
                >
                    <img
                        className={`profilesection-operatoricon`}
                        src={`/Images/OperatorIcon`}
                        style={{
                            opacity: operatorIcon,
                        }}
                    />
                    <img
                        className={`profilesection-profileimage`}
                        src={this._userProfile.icon ?? `/Images/OperatorIcon`}
                        style={{
                            opacity: profileIcon,
                        }}
                    />
                </div>
            </div>
        );
    }
}
